import { createGlobalStyle } from 'styled-components';
import 'semantic-ui-css/semantic.min.css';
import 'react-toastify/dist/ReactToastify.css';

export default createGlobalStyle`
  html, body, #root {
  height: 100%;
  font-family: 'Lexend Deca', sans-serif;
  }

  html, body, #root > div {
  height: 100%;
  button:focus {outline:0;}
  }

  // To fix Amplify container style
  .Section__container___3YYTG {
    flex: 1;
  }
`;
